<template>
  <div class="panel">
    <a
      class="panel-block"
      v-for="huntArea in huntAreas"
      :key="huntArea.id"
      @click="huntAreaSelected(huntArea)"
      :class="{'has-background-grey-dark': isSelectedHuntArea(huntArea), 'has-text-light': isSelectedHuntArea(huntArea)}"
    >
      <span class="panel-icon">
        <i
          class="icon-compass has-text-weight-bold"
          :class="{'has-text-light': isSelectedHuntArea(huntArea)}"
          aria-hidden="true"
        ></i>
      </span>

      <div class="container">
        <span class="is-pulled-left">{{huntArea.name}}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "HuntAreaSearchResultList",

  props: {
    huntAreas: {
      type: Array,
      default: () => ([])
    },

    selectedHuntAreaId: {
      type: String
    }
  },

  computed: {
  },

  methods: {
    huntAreaSelected(huntArea) {
      this.$emit('hunt-area-selected', huntArea);
    },

    isSelectedHuntArea(huntArea) {
      if (!this.selectedHuntAreaId) {
        return false;
      }

      return this.selectedHuntAreaId === huntArea.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.panel {
  min-width: 300px;
}
</style>
